import { Box, Button, Typography, useTheme } from "@mui/material";
import { useAuth } from "../../authentication/AuthProvider";
import { MdExitToApp } from "react-icons/md";
import { useLocation } from "react-router-dom";
import routing from "../../routing";

const ImpersonationBanner = () => {
    const { isImpersonating, stopImpersonating, user } = useAuth();
    const location = useLocation();
    const theme = useTheme();

    // Do not show banner on login or register pages
    const isAuthPage = location.pathname === routing.login || location.pathname === routing.register || location.pathname === "/";

    if (!isImpersonating || isAuthPage) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                bottom: 24,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 9999,
                background: "linear-gradient(135deg, rgba(249, 115, 22, 0.9) 0%, rgba(234, 88, 12, 0.95) 100%)",
                backdropFilter: "blur(12px)",
                color: "#fff",
                py: 0.8,
                px: 2.5,
                borderRadius: "100px", // Floating Pill shape
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                boxShadow: "0 10px 40px rgba(249, 115, 22, 0.3)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                transition: "all 0.3s ease",
            }}
        >
            <Typography
                variant="body2"
                fontWeight="600"
                sx={{
                    fontSize: '0.85rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    letterSpacing: '0.3px'
                }}
            >
                <span style={{ fontSize: '1.2rem', animation: 'pulse 2s infinite' }}>🛡️</span>
                {user?.user_id}
            </Typography>

            <Box sx={{ width: '1px', height: '16px', bgcolor: 'rgba(255,255,255,0.3)' }} />

            <Button
                variant="text"
                size="small"
                onClick={stopImpersonating}
                startIcon={<MdExitToApp style={{ fontSize: '1.1rem' }} />}
                sx={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: '0.75rem',
                    p: 0,
                    minWidth: 'auto',
                    textTransform: 'none',
                    "&:hover": {
                        bgcolor: "transparent",
                        opacity: 0.8,
                        transform: 'translateX(2px)'
                    },
                    transition: 'all 0.2s'
                }}
            >
                Exit
            </Button>

            <style>
                {`
                @keyframes pulse {
                    0% { opacity: 1; }
                    50% { opacity: 0.7; }
                    100% { opacity: 1; }
                }
                `}
            </style>
        </Box>
    );
};

export default ImpersonationBanner;
